export default function setCameraToActive(state, { id }) {
  const { cameras } = state
  const currentCamera = cameras.find(c => c.active === true)
  const deactivatedCamera = currentCamera && currentCamera.id !== id && Object.assign({}, currentCamera, { active: false })
  const cameraToSwitchTo = Object.assign({}, cameras.find(c => c.id === id), { active: true })

  const camerasToAdd = [deactivatedCamera, cameraToSwitchTo].filter(Boolean)

  return Object.assign({}, state, {
    cameras: cameras
              .filter(c => !camerasToAdd.map(c => c.id).includes(c.id))
              .concat(...camerasToAdd),
    ui: {
      ...state.ui,
      sidebarView: 'cameraDetails'
    },
    currentEntity: {
      id,
      type: 'camera'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/setCameraToActive.js